var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wave",rawName:"v-wave"}],staticClass:"chip",style:({ background: _vm.active? _vm.background: '#FF5E56', color: _vm.active? _vm.color: 'white'})},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }